import { LogLevel } from "@azure/msal-browser";
import config from "./config";

export const b2cPolicies = {
  names: {
    signUpSignIn: config.MSAL_POLICY,
  },
  authorities: {
    signUpSignIn: {
      authority: config.MSAL_AUTHORITY,
    },
  },
  authorityDomain: config.MSAL_AUTHORITY_AUTHORITIES,
};

export const msalConfig = {
  auth: {
    issuer: config.MSAL_ISSUER,
    clientId: config.MSAL_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: config.MSAL_REDIRECT_URI,
    postLogoutRedirectUri: config.POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    // Set this to "true" if you are having issues on IE11 or Edge
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  apiTodoList: {
    endpoint: "http://localhost:5000/api/todolist",
    scopes: {
      read: ["https://fabrikamb2c.onmicrosoft.com/TodoList/ToDoList.Read"],
      write: [
        "https://fabrikamb2c.onmicrosoft.com/TodoList/ToDoList.ReadWrite",
      ],
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [
    ...protectedResources.apiTodoList.scopes.read,
    ...protectedResources.apiTodoList.scopes.write,
  ],
};
export const tokenRequest = {
  scopes: [config.SCOPE_USER_READWRITE_ALL],
};
